import { comments } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            观众热评
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            影迷真实反馈
          </h2>
          <p className="mt-2 text-sm text-foreground-600">来看看大家怎么说</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-100 rounded-xl p-5 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.author}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-950 truncate">{comment.author}</h3>
                  <span className="text-xs text-foreground-500">{comment.date}</span>
                </div>
              </div>

              <div className="flex items-center gap-0.5 mb-2">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${i < comment.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-300'}`}
                  ></i>
                ))}
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed flex-1">{comment.content}</p>

              <span className="mt-3 inline-block self-start px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                {comment.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}